module.exports = __webpack_public_path__ + "static/media/kilimanjaro-on.23ef2dea.png";